/**
 * Mindbyte cookie banner — copy overrides only.
 * Visual styling lives in brand-overrides.css; Shopify layout/behavior unchanged.
 */
(function () {
  var TITLE_PREFIX = 'COOKIES DETECTED ';
  var TITLE_SMILEY = '(✧_✧)';
  var BODY_COPY =
    'By continuing to browse this site, you agree to feed us delicious digital cookies.';
  var POLICY_LABEL = 'Our cookie policy';
  var rootObserver = null;
  var bannerObserver = null;

  function setTitle(title) {
    if (!title) return;
    var smiley = title.querySelector('.mindbyte-cookie-banner__smiley');
    if (smiley && title.childNodes.length >= 2) return;

    while (title.firstChild) title.removeChild(title.firstChild);
    title.appendChild(document.createTextNode(TITLE_PREFIX));
    smiley = document.createElement('span');
    smiley.className = 'mindbyte-cookie-banner__smiley';
    smiley.textContent = TITLE_SMILEY;
    title.appendChild(smiley);
  }

  function applyCopy(banner) {
    if (!banner) return false;
    banner.classList.add('mindbyte-cookie-banner');

    var body = banner.querySelector('.shopify-pc__banner__body');
    var title = banner.querySelector('#shopify-pc__banner__body-title');
    if (!title && body) {
      title = document.createElement('h2');
      title.id = 'shopify-pc__banner__body-title';
      title.className = 'mindbyte-cookie-banner__title';
      body.insertBefore(title, body.firstChild);
    }
    setTitle(title);

    if (banner.dataset.mindbyteCopy === '1') {
      setTitle(title);
      return true;
    }
    banner.dataset.mindbyteCopy = '1';

    var paragraph = banner.querySelector('.shopify-pc__banner__body p');
    if (paragraph) {
      var policyLink = paragraph.querySelector('a');
      if (policyLink) {
        policyLink.textContent = POLICY_LABEL;
        while (paragraph.firstChild) paragraph.removeChild(paragraph.firstChild);
        paragraph.appendChild(document.createTextNode(BODY_COPY + ' '));
        paragraph.appendChild(policyLink);
      } else {
        paragraph.textContent = BODY_COPY;
      }
    }

    var policyOnly = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (policyOnly) policyOnly.textContent = POLICY_LABEL;

    return true;
  }

  function watchBanner(banner) {
    if (bannerObserver || !banner) return;
    bannerObserver = new MutationObserver(function () {
      applyCopy(banner);
    });
    bannerObserver.observe(banner, { childList: true, subtree: true, characterData: true });
  }

  function stopRootObserver() {
    if (rootObserver) {
      rootObserver.disconnect();
      rootObserver = null;
    }
  }

  function scan() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) {
      if (bannerObserver) {
        bannerObserver.disconnect();
        bannerObserver = null;
      }
      return;
    }

    if (applyCopy(banner)) {
      watchBanner(banner);
      // Document-wide watch only needed until the banner mounts.
      stopRootObserver();
    }
  }

  function startRootObserver() {
    if (rootObserver) return;
    var root = document.body || document.documentElement;
    rootObserver = new MutationObserver(scan);
    rootObserver.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
      if (!document.getElementById('shopify-pc__banner')) startRootObserver();
    });
  } else {
    scan();
    if (!document.getElementById('shopify-pc__banner')) startRootObserver();
  }
})();
